<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-tabs
        style="border-top-right-radius: 0.5rem; border-top-left-radius: 0.5rem"
        grow
        background-color="primary"
        active-class="subtitle-1 font-weight-bold"
        center-active
        v-model="activeTab"
      >
        <v-tab
          class="tabText"
          @click.prevent="setGetFavoritas(false, false, null)"
          :key="0"
        >
          Cronômetros
          <span class="tab-count" :class="{ 'tab-count--hidden': !(flg_favorita === false && !loading && !pasta && data.totalItems > 0) }">
            {{ flg_favorita === false && !loading && !pasta && data.totalItems > 0 ? data.totalItems : '0' }}
          </span>
        </v-tab>
        <v-tab
          class="tabText"
          @click.prevent="setGetFavoritas(true, false, null)"
          :key="1"
        >
          Favoritos
          <span class="tab-count" :class="{ 'tab-count--hidden': !(flg_favorita === true && !loading && !pasta && data.totalItems > 0) }">
            {{ flg_favorita === true && !loading && !pasta && data.totalItems > 0 ? data.totalItems : '0' }}
          </span>
        </v-tab>
        <!-- <v-tab
          class="tabText"
          @click.prevent="setGetFavoritas(false, true, pastas[0]?.cod_pasta)"
          :key="2"
        >
          Pastas
          {{
            `${
              flg_favorita === false && cod_pasta !== 0 && !loading
                ? `(${data.totalItems})`
                : ""
            }`
          }}
        </v-tab> -->
      </v-tabs>

      <v-container class="colab-toolbar-container" fluid v-if="cod_producao">
        <div class="colab-toolbar">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            solo flat dense hide-details
            placeholder=""
            background-color="surface_tertiary"
            v-model="filtro_texto"
            @input="onChange"
            @keypress.enter="handleClickEnter"
            aria-label="Buscar"
            class="colab-search"
          />

          <v-select
            v-if="activeTab === 2"
            v-model="cod_pasta"
            :items="pastas"
            placeholder="Pasta"
            solo flat dense hide-details
            background-color="surface_tertiary"
            item-value="cod_pasta"
            item-text="dsc_nome_pasta"
            @change="changePastas(cod_pasta)"
            class="colab-dropdown"
          />
        </div>

        <div v-if="data" class="columnWrapper">
          <template v-if="data">
            <template>
              <div
                v-for="item in data.items"
                :key="item.id"
                class="card-item-wrapper drag-source"
                :class="{ 'drag-source--dragging': draggingId === item.id }"
                draggable
                @dragstart="startDrag($event, item)"
                @dragend="endDrag"
              >
                <CardCronometro
                  :item="item"
                  :get-cronometros-producao="getCronometrosProducao"
                  :get-cronometro-em-exibicao="getCronometroEmExibicao"
                  :current-page="currentCronometrosPage"
                  :is-favorita-tab="flg_favorita"
                  :cod_pasta="cod_pasta"
                />
              </div>
            </template>
          </template>
        </div>
      </v-container>
    </v-card-title>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import { apiClient } from "@/services/api";
import { capitalizeString } from "@/utils/capitalizeString";
import CardCronometro from "../Cards/Cronometros/CardCronometro.vue";
import { dragSourceMixin } from "@/mixins/dragAndDrop";
export default {
  mixins: [dragSourceMixin],
  components: {
    CardCronometro,
  },
  props: {
    data: { type: [Array, Object] },
    showModal: Function,
    closeModal: Function,
    currentCronometrosPage: Number,
    cod_producao: Number,
    changePasta: Function,
  },
  data() {
    return {
      imagem_url: "",
      isModalFiltrosVisible: false,
      filtro_texto: "",
      flg_favorita: false,
      isModalImagemAprovadasVisible: false,
      midia_url_aprovadas: "",
      media_type: "",
      debounce: null,
      loading: false,
      activeTab: 0,
      pasta: false,
      cod_pasta: null,
      dragIdField: 'id',
    };
  },
  beforeMount() {
    this.filtro_texto = localStorage.getItem("@socialcam/filtro_texto_cronometro") || "";
    this.flg_favorita =
      JSON.parse(localStorage.getItem("@socialcam/flg_favorita_cronometros")) || false;
    this.activeTab = this.flg_favorita ? 1 : 0;
    this.setFlgFavorita(this.flg_favorita);
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    filtros() {
      return localStorage.getItem("@socialcam/filtros") || "";
    },
    ...mapGetters({
      pastas: "pastas/getterPastas",
    }),
  },
  filters: {
    formatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    formatedHour(date) {
      return new Date(date).toLocaleTimeString().split(":").slice(0, 2).join(":");
    },
  },
  methods: {
    ...mapActions({
      getCronometrosProducao: "cronometros/getCronometrosByProducao",
      getCronometroEmExibicao: "cronometros/getCronometroEmExibicao",
      setFlgFavorita: "cronometros/setFlgFavorita",
      setFiltroCronometros: "cronometros/setFiltroCronometros",
    }),
    async showModalImagem(midia_url_aprovadas, media_type) {
      this.isModalImagemAprovadasVisible = true;
      this.midia_url_aprovadas = midia_url_aprovadas;
      this.media_type = media_type;
    },
    async closeModalImagem() {
      this.isModalImagemAprovadasVisible = false;
    },
    capitalize(string) {
      return capitalizeString(string);
    },
    async handleClickEnter() {
      await this.getCronometrosProducao({
        cod_producao: this.cod_producao,
        filtro_texto: this.$store.state.cronometros.filtroCronometros,
        flg_favorita: this.flg_favorita,
        size: 5,
        cod_pasta: this.cod_pasta,
        page: this.currentCronometrosPage,
      });
    },
    async changePastas(cod_pasta) {
      await this.getCronometrosProducao({
        cod_producao: this.cod_producao,
        filtro_texto: this.$store.state.cronometros.filtroCronometros,
        flg_favorita: this.flg_favorita,
        size: 5,
        cod_pasta: this.cod_pasta,
        page: this.currentCronometrosPage,
      });
      await this.changePasta(cod_pasta);
    },
    async setGetFavoritas(flg_favorita, pasta, cod_pasta) {
      this.flg_favorita = flg_favorita;
      this.pasta = pasta;
      this.cod_pasta =
        this.pasta && this.pastas.length > 0 ? cod_pasta : this.pasta ? 0 : null;
      await this.changePasta(this.cod_pasta);
      this.$store.commit("pastas/setCodPasta", this.cod_pasta);
      this.$store.commit("pastas/setIsPastaAtiva", pasta);
      localStorage.setItem("@socialcam/flg_favorita_cronometros", flg_favorita);
      localStorage.setItem("@socialcam/isPastaAtiva", pasta);
      localStorage.setItem("@socialcam/cod_pasta", this.cod_pasta);
      try {
        this.loading = true;
        localStorage.setItem("@socialcam/flg_favorita_cronometros", flg_favorita);
        // const loadPage = this.flg_favorita ? 1 : this.currentAprovadasPage;
        await this.getCronometrosProducao({
          cod_producao: this.cod_producao,
          filtro_texto: this.$store.state.cronometros.filtroCronometros,
          flg_favorita: this.flg_favorita,
          size: 5,
          cod_pasta: this.cod_pasta,
          page: this.currentCronometrosPage,
        });
      } catch (error) {
        console.error(error);
        return this.$toast.error("Não foi possível buscar as favoritas");
      } finally {
        this.loading = false;
      }
    },
    onChange(e) {
      localStorage.setItem("@socialcam/filtro_texto_cronometros", e);
      this.setFiltroCronometros(e);

      clearTimeout(this.debounce);

      this.debounce = setTimeout(async () => {
        await this.getCronometrosProducao({
          cod_producao: this.cod_producao,
          filtro_texto: this.$store.state.cronometros.filtroCronometros,
          flg_favorita: this.flg_favorita,
          size: 5,
          cod_pasta: this.cod_pasta,
          page: this.currentCronometrosPage,
        });
      }, 1500);
    },
  },
  watch: {
    activeTab: function (newValue) {
      this.setFlgFavorita(newValue === 1 ? true : false);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-tab {
  text-transform: none !important;
  color: #171717 !important;
}

.v-text-field__details {
  display: none !important;
}

.card-item-wrapper {
  margin-bottom: 8px;
}
</style>
